import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router'
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  )
  {}
  produ:string
  title = 'obao-ui-my';
  /* DCI update (11 June 2020): Add function to determine current page for progress bar start*/
  public progressBar() {
    var first_director_flow_pb_total_screen = 14;
    function progressWidth(total_screen) {
      var ts = total_screen;
      var curr_scr = $(".component-page").data("page-id");
   //   console.log("Current-screen:" + curr_scr);
   //   console.log("total screen:" + ts);
      var prog_curr_width = Math.floor(curr_scr / ts * 100);
   //   console.log("total width percent:" + prog_curr_width + "%");
      $(".progress-bar").css("width", prog_curr_width + "%");
    }
    if ($(".component-page").data("page-id") <= first_director_flow_pb_total_screen) {
      progressWidth(first_director_flow_pb_total_screen);
    }
    
    if($(".component-page").data("page-id")==0){
      $(".progress-bar").css("width","0px");
    }
  }
  /* DCI update (11 June 2020): Add function to determine current page for progress bar end*/

  public loadCustomDropdown(){
    var x, i, j, l, ll, selElmnt, a, b, c;
    /* DCI: Look for any elements with the class "custom-select": */
    x = document.getElementsByClassName("custom-select");
    l = x.length;
    for (i = 0; i < l; i++) {
      selElmnt = x[i].getElementsByTagName("select")[0];
      ll = selElmnt.length;
      /* For each element, create a new DIV that will act as the selected item: */
      a = document.createElement("DIV");
      a.setAttribute("class", "select-selected");
      a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
      x[i].appendChild(a);
      /* DCI: For each element, create a new DIV that will contain the option list: */
      b = document.createElement("DIV");
      b.setAttribute("class", "select-items select-hide");
      for (j = 1; j < ll; j++) {
        /* DCI: For each option in the original select element,
        create a new DIV that will act as an option item: */
        c = document.createElement("DIV");
        c.innerHTML = selElmnt.options[j].innerHTML;
        c.addEventListener("click", function (e) {
          /* DCI: When an item is clicked, update the original select box,
          and the selected item: */
          var y, i, k, s, h, sl, yl;
          s = this.parentNode.parentNode.getElementsByTagName("select")[0];
          sl = s.length;
          h = this.parentNode.previousSibling;
          for (i = 0; i < sl; i++) {
            if (s.options[i].innerHTML == this.innerHTML) {
              s.selectedIndex = i;
              h.innerHTML = this.innerHTML;
              y = this.parentNode.getElementsByClassName("same-as-selected");
              yl = y.length;
              for (k = 0; k < yl; k++) {
                y[k].removeAttribute("class");
              }
              this.setAttribute("class", "same-as-selected");
              break;
            }
          }
          h.click();
        });
        b.appendChild(c);
      }
      x[i].appendChild(b);
      a.addEventListener("click", function (e) {
        /*DCI: When the select box is clicked, close any other select boxes,
        and open/close the current select box: */
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");
      });
    }

    function closeAllSelect(elmnt) {
      /*DCI: A function that will close all select boxes in the document,
      except the current select box: */
      var x, y, i, xl, yl, arrNo = [];
      x = document.getElementsByClassName("select-items");
      y = document.getElementsByClassName("select-selected");
      xl = x.length;
      yl = y.length;
      for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
          arrNo.push(i)
        } else {
          y[i].classList.remove("select-arrow-active");
        }
      }
      for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
          x[i].classList.add("select-hide");
        }
      }
    }
    /*DCI: If the user clicks anywhere outside the select box,
    then close all select boxes: */
    document.addEventListener("click", closeAllSelect);

     /*DCI:Control the behaviour of custom-select border color when clicked start*/
     var clicked_count = 0;
     $(".select-selected").click(function () {
        clicked_count++;
        if (clicked_count == 1) {
          $(this).parent().css("border", "1px solid #00aea6")
       //   console.log("Dropdown being click");
        } else if (clicked_count == 2) {
          $(".custom-select").css("border", "1px solid #d2d2d2")
          clicked_count = 0;
        }
        $(document).click(function () {
          $(".custom-select").css("border", "1px solid #d2d2d2")
          clicked_count = 0;
        });

      });
   
      /*DCI:Control the behaviour of custom-select border color when clicked end*/
  }
  ngOnInit() {
    // this.router.events.forEach(item => {
    //   if(item instanceof NavigationEnd) {
    //     window['dataLayer'].push({
    //       event: 'page',
    //       pageName: item.url
    //     });
    //   }
    // });
  }

  onShowModal(){
    $('#sessionModal').modal("show");
  }
  onCloseToStart(){
    var params = JSON.parse(localStorage.getItem("SavedQueryParams"));
    delete params.productdescription;
    this.router.navigate(['/start'], {queryParams : params});
  }
}
